'use client';

import Footer from '@/components/footer/FooterWrapper';
import HeaderRefresh from '@/components/homepageRefresh/header/Header';
import HomepageLayout from '@/components/homepageRefresh/homepage/HomepageLayout';
import HomepageThemeProvider from '@/components/homepageRefresh/homepage/HomepageThemeProvider';

export default function Homepage() {
	return (
		<>
			<HomepageThemeProvider>
				<HeaderRefresh />
				<HomepageLayout />
			</HomepageThemeProvider>
			<Footer />
		</>
	);
}
